var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { DisplayMode } from "core/codegen/types";
import { mq } from "core/styles/snippets";
import { HydrationHelper } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { renderEmbed as renderContentEmbed } from "pages/commonPage/ContentView";
import { renderEmbed as renderFullScreenEmbed } from "pages/commonPage/FullscreenView";
import { renderEmbed as renderSlotEmbed } from "pages/commonPage/SlotView";
import React from "react";
import styled from "styled-components";
function isCompatible(program) {
    return program.embed !== null;
}
function renderEmbed(embed) {
    switch (embed.displayMode) {
        case DisplayMode.Fullscreen:
            return renderFullScreenEmbed(embed);
        case DisplayMode.Content:
            return renderContentEmbed(embed);
        case DisplayMode.Slot:
            return renderSlotEmbed(embed);
    }
}
export var block = function (data) {
    if (!isCompatible(data))
        return Option.none;
    var fullScreen = data.embed.displayMode !== DisplayMode.Slot;
    var minHeight = 'auto';
    if (data.slug.includes("/the-masked-singer")) {
        minHeight = '100vh';
    }
    if (data.slug.includes("/the-voice-van-vlaanderen") && data.embed.displayMode === DisplayMode.Slot) {
        minHeight = '1500px';
    }
    if (!HydrationHelper.useComplete()) {
        return Option.some({
            key: "programEmbed",
            View: function () {
                return React.createElement(Container, { variant: data.variant, fullScreen: fullScreen, minHeight: minHeight });
            },
        });
    }
    return Option.some({
        key: "programEmbed",
        View: function () { return (React.createElement(Container, { variant: data.variant, fullScreen: fullScreen, minHeight: minHeight }, renderEmbed(data.embed))); },
    });
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin: ", ";\n  background-color: transparent !important;\n  line-height: 0;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin: 0 1rem;\n    \n  iframe {\n      min-height: ", ";\n  }  \n\n  ", " {\n    margin: 0 1.5rem;\n  }\n\n  ", " {\n    margin: 0 2.5rem;\n  }\n\n  ", " {\n    margin: 0 5rem;\n  }\n\n  ", " {\n    margin: 0 auto;\n    max-width: 110rem;\n  }\n"], ["\n  margin-top: ", ";\n  margin: ", ";\n  background-color: transparent !important;\n  line-height: 0;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin: 0 1rem;\n    \n  iframe {\n      min-height: ", ";\n  }  \n\n  ", " {\n    margin: 0 1.5rem;\n  }\n\n  ", " {\n    margin: 0 2.5rem;\n  }\n\n  ", " {\n    margin: 0 5rem;\n  }\n\n  ", " {\n    margin: 0 auto;\n    max-width: 110rem;\n  }\n"])), function (p) { return (p.variant === "vtmgo" ? "60px" : "20px"); }, function (p) { return p.fullScreen && "0"; }, function (p) { return p.minHeight; }, mq.minWidth("48rem"), mq.minWidth("64rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var templateObject_1;
